import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ReactGridLayout from 'react-grid-layout';
import { IDynamicCard } from 'src/app/pages/HomePage/Card/home-card.config';
import { DashboardState } from 'src/app/pages/HomePage/home-page.config';
import { surferApiSlice } from 'src/app/redux/api/surferApiSlice';
import { DataCountBodyType, DataCountResultType } from 'src/app/services/surfer-service/surfer.service.type';
import { finalUrlsConfig } from 'src/configs/url.config';

const initialState: DashboardState = {
  layout: [],
  // toolbox: [],
};

function sortLayout(ob1: ReactGridLayout.Layout, ob2: ReactGridLayout.Layout) {
  if (ob1.y > ob2.y) {
    return 1;
  }
  if (ob1.y < ob2.y) {
    return -1;
  }
  if (ob1.x < ob2.x) {
    return -1;
  }
  if (ob1.x > ob2.x) {
    return 1;
  }
  return 0;
}

const lastIndexOfGrid = (id: string, layout: ReactGridLayout.Layout[]) => {
  const lastItem = layout.sort(sortLayout)[layout.length - 1];
  const itemLayout: ReactGridLayout.Layout = {
    x: 0,
    y: 0,
    w: 1,
    h: 1,
    i: id,
    maxH: 2,
    maxW: 2,
    isResizable: false,
  };

  if (lastItem) {
    itemLayout.x = (lastItem.x + 1) % 4;
    itemLayout.y = itemLayout.x === 0 ? lastItem.y + 1 : lastItem.y;
  }

  return { ...itemLayout };
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    // dropToLayout: (state, action: PayloadAction<ReactGridLayout.Layout>) => {
    //   state.toolbox = state.toolbox.filter((id) => id !== action.payload.i);
    //   state.layout.push(action.payload);
    // },

    setDashboard: (state, action: PayloadAction<DashboardState>) => {
      state.layout = action.payload.layout;
      // state.toolbox = action.payload.toolbox;
    },
    // addCardToToolbox: (state, action: PayloadAction<string>) => {
    //   state.layout = state.layout.filter((item) => item.i !== action.payload);
    //   state.toolbox.push(action.payload);
    // },
    addCardToLayout: (state, action: PayloadAction<IDynamicCard<any>>) => {
      const newLayout = lastIndexOfGrid(action.payload.id, state.layout);
      // state.toolbox = state.toolbox.filter((id) => id !== action.payload.id);
      state.layout.push(newLayout);
    },
    layoutResized: (state, action: PayloadAction<ReactGridLayout.Layout>) => {
      const index = state.layout.findIndex((item) => item.i === action.payload.i);
      state.layout[index] = action.payload;
    },
    // deleteFromToolbox: (state, action: PayloadAction<string>) => {
    //   state.toolbox = state.toolbox.filter((id) => id !== action.payload);
    // },
    cardAdded: (state, action: PayloadAction<IDynamicCard<any>>) => {
      state.layout.push(lastIndexOfGrid(action.payload.id, state.layout));
    },
  },
});

export const dashboardApiSlice = surferApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardData: builder.mutation<DataCountResultType, DataCountBodyType>({
      query: (data) => ({
        url: finalUrlsConfig().surfer.dashboard,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { setDashboard, addCardToLayout, layoutResized, cardAdded } = dashboardSlice.actions;
export default dashboardSlice.reducer;

export const { useGetDashboardDataMutation } = dashboardApiSlice;
